<template>
  <div>
    <addPersonEditNew v-if="Number(type) === PLAN_TYPE.PERSON" :mode="MODE_TYPE.COPY" />
    <addEnterEditNew v-else-if="Number(type) === PLAN_TYPE.ENTER" :mode="MODE_TYPE.COPY" />
  </div>
</template>
<script setup>
import addPersonEditNew from './components/addPersonEditNew.vue'
import addEnterEditNew from './components/addEnterEditNew.vue'
import { useRoute } from '@/utils/useUtils'
import { MODE_TYPE, PLAN_TYPE } from './const'

const route = useRoute()
const { type } = route.query
</script>
